<template>
	<div class="card rounded-2">
		<div class="card-body px-0 pt-0 pb-2">
			<div class="p-0 px-2">
				<div class="table-responsive py-2">
					<DataTable
						:columns="columns"
						:options="options"
						:ajax="ajaxRequest"
						ref="dataTableRef"
						class="table table-hover display nowrap"
						width="100%"
					>
						<thead>
							<tr>
								<th>Id#</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Invoice Number
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Shed
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Vehicle Number
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Sub Total
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									VAT
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Disc.
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Total
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Date
								</th>
								<th
									class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
								>
									Actions
								</th>
							</tr>
						</thead>
					</DataTable>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import authStore from "../../store/auth";
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import { ref, watch, onMounted,inject } from "vue";

const baseUrl = inject('baseUrl');


DataTable.use(DataTablesCore);

const props = defineProps({
	selectedShed: {
		type: String,
		default: "",
	},
	selectedVehicle: {
		type: String,
		default: "",
	},
	selectedDateRangeValue: {
		type: String,
		default: "",
	},
	selectedDateRange: {
		type: Array,
		default: () => [],
	},
});

const authState = authStore.state;
const dataTableRef = ref();
let dt;



const columns = [
	{ data: "id", visible: false },
	{ data: "invoice_number", className: "mb-0 small" },
	{ data: "shed_name", className: "mb-0 small" },
	{ data: "company_vehicle_number", className: "mb-0 small" },
	{ data: "sub_total", className: "mb-0 small" },
	{ data: "vat", className: "mb-0 small" },
	{ data: "discount", className: "mb-0 small" },
	{ data: "total", className: "mb-0 small" },
	{ data: "created_at", className: "mb-0 small" },
	{
		data: null,
		className: "text-center",
		render: function (rowData) {
			return `<a href="${baseUrl.replace("/api/v1","")}/view-invoice/${rowData.uuid}" target="_blank" role="button" class="btn btn-sm btn-icon view-invoice-products-btn mb-2" title="View/Download Invoice">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                  <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                  <path d="M9 7l1 0" />
                  <path d="M9 13l6 0" />
                  <path d="M13 17l2 0" />
                </svg>
              </a>`;
		},
	},
];

const options = ref({
	processing: true,
	serverSide: true,
	autoWidth: false,
	fixedHeader: true,
	order: [[0, "desc"]],
	paging: true,
	searching: true,
	lengthChange: true,
	pageLength: 10,
	language: {
		search: "Search all records:",
	},
	ajax: {
		url: `${baseUrl}/get-company-invoices-details`,
		type: "GET",
		data: (d) => {
			d.shed = props.selectedShed;
			d.vehicle = props.selectedVehicle;
			d.date = props.selectedDateRangeValue;
			d.dateRange = props.selectedDateRange;
		},
		beforeSend: (xhr) => {
			xhr.setRequestHeader("Authorization", `Bearer ${authState.token}`);
		},
	},
});

watch(
	() => [props.selectedShed, props.selectedVehicle, props.selectedDateRangeValue, props.selectedDateRange],
	() => {
		if (dt) {
			dt.ajax.reload(null, false);
		}
	}
);

onMounted(async () => {
	dt = dataTableRef.value.dt;
});
</script>
